import { WhichEventScreen } from '@/screens/name-screen/WhichEventScreen'

export default function () {
  return <WhichEventScreen />
}
